import { Agreement } from "@partiu-vantagens/partiu-sdk/dist/types/agreement";
import { axiosInstanceV2, partiuClient } from "../axios";

export interface CreateReferralPayload {
  agreement: number;
  document: string;
  name?: string;
  telephone?: string;
  email?: string;
}

export function createReferral(payload: CreateReferralPayload) {
  return axiosInstanceV2
    .post("/referral/", { ...payload, created_from: "pdv" })
    .then(({ data }) => data);
}

export function getMyReferrals() {
  return axiosInstanceV2.get("/referral/").then(({ data }) => data.results);
}

export function getReferrableAgreements(): Promise<Agreement[]> {
  return axiosInstanceV2.get("/referral/agreements/").then(({ data }) => data);
}

export interface ReferralSummary {
  total_by_status: {
    created: number;
    confirmed: number;
    paid: number;
    expired: number;
  };
  total_paid: number;
  total_to_receive: number;
}

export function getReferralSummary(): Promise<ReferralSummary> {
  return axiosInstanceV2.get("/referral/summary/").then(({ data }) => data);
}

export function canDocumentBeReferred(
  agreementId: number,
  document: string,
): Promise<boolean> {
  console.log("PARAMS", agreementId, document);
  return axiosInstanceV2
    .post("/referral/check/", { agreement: agreementId, document })
    .then(({ status }) => status === 200);
}
